import Swiper, { Navigation, Autoplay } from "swiper";
Swiper.use([Navigation, Autoplay]);

document.addEventListener("DOMContentLoaded", () => {
  const offers__swiper = document.querySelector(".offers-slider .offers-list");
  if (offers__swiper) {
    let offers = new Swiper(".offers-slider .offers-list", {
      grabCursor: true,
      loop: true,
      autoplay: {
        delay: 3600,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      navigation: {
        prevEl: ".offers-slider__arrows .prev",
        nextEl: ".offers-slider__arrows .next",
      },
      slidesPerView: 1,
      spaceBetween: 20,
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        992: {
          slidesPerView: 3,
        },
      },
    });
  }
});
